import { Image } from '@hover/blueprint';
import type { FlexProps } from '@hover/blueprint/chakra';
import { Flex } from '@hover/blueprint/chakra';
import React from 'react';

import { selectionStyles } from 'src/modules/designStudio/components/SelectionButton';

export interface MaterialButtonProps extends FlexProps {
  onClick: () => void;
  isSelected: boolean;
  thumbnail: string;
  color: string;
}

export const MaterialButton = ({
  onClick,
  isSelected,
  thumbnail,
  color,
  children,
  ...rest
}: MaterialButtonProps) => (
  <Flex flexDirection="column" {...rest} height="100%" width="100%">
    <Flex
      as="button"
      borderRadius={300}
      cursor="pointer"
      height="100%"
      onClick={onClick}
      position="relative"
      width="100%"
      {...selectionStyles({ isSelected })}
      backgroundColor={color ?? 'neutral.0'}
    >
      <Image
        alt=""
        borderRadius="inherit"
        display="block"
        height="100%"
        mixBlendMode={thumbnail ? 'multiply' : undefined}
        src={thumbnail ?? undefined}
        width="100%"
      />
    </Flex>
    {children}
  </Flex>
);
